import { render, staticRenderFns } from "./CasesHistoryChart.vue?vue&type=template&id=b80c0f60"
import script from "./CasesHistoryChart.vue?vue&type=script&lang=js"
export * from "./CasesHistoryChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports